import currency from 'currency.js';

export const GBP = (value: any) => currency(value, { symbol: '£' });
